// @flow
export const isString = (input: mixed | null | void): boolean =>
  typeof input === 'string';
